import { assessmentsConstants } from '../../_constants';
import { assessmentsService } from '../../_services';

export const getAssessementsListAction = {
    getAssessementsHandler
};

function getAssessementsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        assessmentsService.getAssessementsHandler(data)
            .then(
                getAssessement => {
                    dispatch(success(getAssessement));
                    if(callback) {
                        callback(getAssessement)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: assessmentsConstants.REQUEST_ASSESSMENT_LIST} }
    function success(getAssessement) { return { type: assessmentsConstants.RECEIVE_ASSESSMENT_LIST, getAssessement } }
    function failure(error) { return { type: assessmentsConstants.ASSESSMENT_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/Assessments/getQuestionsList.action.js